export default __webpack_public_path__ + "static/media/mobile4.c901dcba.webp";